import { render, staticRenderFns } from "./service-items.vue?vue&type=template&id=911dc6dc&scoped=true&"
import script from "./service-items.vue?vue&type=script&lang=ts&"
export * from "./service-items.vue?vue&type=script&lang=ts&"
import style0 from "./service-items.vue?vue&type=style&index=0&id=911dc6dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911dc6dc",
  null
  
)

export default component.exports